import React from "react";

interface AnchorProps {
  children?: React.ReactNode;
  href: string;
  style?: React.CSSProperties;
  target?: "_blank";
}

/**
 * Provides navigation wrapping the child.
 */
export function Anchor(props: AnchorProps) {
  const { children, href, style, target } = props;

  return (
    <a style={{ textDecoration: "none", ...style }} href={href} target={target}>
      {children}
    </a>
  );
}
